import React from 'react';

import { Box, Typography } from '@mui/material';

import { LereToursPricingSuggestion } from '../types';

function formatNumber(value: number | null): string {
  if (value == null) {
    return '—';
  }
  return value.toLocaleString();
}

function formatPercent(value: number | null): string {
  if (value == null) {
    return '—';
  }
  return `${(value * 100).toFixed(1)}%`;
}

export default function ToursCapacitySalesFormatter({ row }: { row: LereToursPricingSuggestion }) {
  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1 }}>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Pax Sold / Max:
        </Typography>{' '}
        {formatNumber(row.total_pax_sold)} / {formatNumber(row.max_pax)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Hedged Pax:
        </Typography>{' '}
        {formatNumber(row.hedged_pax)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Book Rate:
        </Typography>{' '}
        {formatPercent(row.current_book_rate)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Predicted Pax:
        </Typography>{' '}
        {row.predicted_total_pax ?? '—'}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Hidden:
        </Typography>{' '}
        {row.hidden_departure ? 'Yes' : 'No'}
      </Typography>
      {row.ddop_status && (
        <Typography variant="body2">
          <Typography component="span" fontWeight="bold" variant="body2">
            DDOP:
          </Typography>{' '}
          {row.ddop_status}
        </Typography>
      )}
    </Box>
  );
}
